const dropdown = document.querySelectorAll('.dropdown');
//    dropdown = Array.prototype.slice.call(dropdown, 0);

dropdown.forEach(function (target, index) {
  const button = target.querySelector('.dropdown__button');
  if(!button) return false;

  button.addEventListener('click', function (e) {
    e.preventDefault();
    if(target.classList.contains('open')){
      target.classList.remove('open');
    }else{
      target.classList.add('open');
    }
  });

});

document.body.addEventListener('click', function (e) {
  dropdown.forEach(function (target, index) {
    if(target.classList.contains('open')){
      target.classList.remove('open');
    }
  });
}, true);
